import { registerDecorator, } from 'class-validator';
export function IsNotHtml(validationOptions) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return function (object, propertyName) {
        registerDecorator({
            name: 'IsNotHtml',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate: function (value) {
                    var htmlRegex = /<[a-z][\s\S]*>/i;
                    return !htmlRegex.test(value);
                },
                defaultMessage: function (args) {
                    return "each value in ".concat(args.property, " should not contain HTML");
                },
            },
        });
    };
}
